import { render, staticRenderFns } from "./channelItem.vue?vue&type=template&id=614228a5"
import script from "./channelItem.vue?vue&type=script&lang=js"
export * from "./channelItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports